export class StaffingPlan {
    shiftBlockId: number;
    shiftRecordId?: number;
    workflowTimeFacility: string;
    jobTitleId: number;
    recommended: number;
    projected: number;
    amount: number;
    modifiedByUserName: string;
    modifiedDate: Date;
    importedAmount: number | null;
}
